import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative ml-0 flex h-[50px] cursor-pointer items-center justify-center rounded-(--button-border-radius) border border-current p-3.5 text-base font-semibold whitespace-nowrap transition',
    loading: 'loading absolute transition-opacity',
    children: 'flex-center relative transition-opacity'
  },
  variants: {
    color: {
      primary:
        'text-button-primary-inversion bg-button-primary border-transparent',
      secondary: 'bg-button-secondary border-transparent text-white',
      tertiary:
        'text-button-tertiary-inversion bg-button-tertiary border-transparent',
      transparent:
        'text-button-transparent border-button-transparent bg-transparent',
      ghost: 'border-transparent bg-transparent'
    },
    loading: {
      true: {
        base: 'cursor-default',
        loading: 'opacity-100',
        children: 'opacity-0'
      },
      false: {
        loading: 'opacity-0',
        children: 'opacity-100'
      }
    },
    disabled: {
      true: {
        base: 'cursor-default'
      }
    },
    rounded: {
      full: {
        base: 'rounded-full'
      }
    },
    noBorder: {
      true: {
        base: '!border-0 hover:border-0'
      }
    }
  },
  compoundVariants: [
    {
      loading: false,
      disabled: false,
      color: 'primary',
      class: 'hover:bg-brand-accent'
    },
    {
      loading: false,
      disabled: false,
      color: 'secondary',
      class: 'hover:bg-button-secondary-inversion'
    },
    {
      loading: false,
      disabled: false,
      color: 'tertiary',
      class: 'hover:bg-brand-primary hover:text-button-tertiary'
    },
    {
      loading: false,
      disabled: false,
      color: 'transparent',
      class: 'hover:text-button-primary hover:border-button-primary'
    },
    {
      disabled: true,
      class:
        'bg-button-inactive text-button-inactive-inversion cursor-not-allowed border-transparent'
    }
  ],
  defaultVariants: {
    size: 'base',
    color: 'primary',
    loading: false,
    disabled: false
  }
});
